var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"img-responsive"},[_vm._l((_vm.sizes),function(image_width,screen_width){return _c('source',{key:image_width,attrs:{"media":`(max-width: ${screen_width-1}px)`,"srcset":_vm.sized_src(image_width)}})}),_c('base-image',{staticClass:"img-responsive",attrs:{"src":_vm.src,"alt":_vm.alt}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }